// @flow
import React, { Fragment } from 'react';
import QuoteCard from 'components/common/QuoteCard';
import type { QuoteItem } from 'store/modules/quoting';
import FakeQuoteCard from 'components/common/FakeQuoteCard';
import Tooltip from 'react-tooltip';
import { type UserData } from 'store/modules/user';
import './QuoteCardList.scss';

type Props = {
  quotes?: ?(QuoteItem[]),
  loading: boolean,
  prefetching: boolean,
  width?: number,
  hasEnded: boolean,
  oneColumn?: boolean,
  placeholderCount?: number,
  hideUsername?: boolean,
  isTrending?: boolean,
  user: ?UserData,
};

const createArray = length => Array.from(Array(length).keys());
const getColumnCount = width => {
  const xWide = 1920;
  const wide = 1600;
  const xLarge = 1256;
  const large = 1024;
  const medium = 768;

  if (!width) return 1;

  if (width < medium) return 4;
  if (width < large) return 6;
  if (width < xLarge) return 6;
  if (width < wide) return 6;
  if (width < xWide) return 12;
  return 12;
};

const QuoteCardList = ({ quotes, prefetching, width, oneColumn, user }: Props) => {
  const columnCount = oneColumn ? 1 : getColumnCount(width);
  if (!quotes) return null;
  const quoteList = quotes.map(quote => (
    <QuoteCard
      key={quote.id}
      id={quote.id}
      thumbnail={quote.thumbnail}
      title={quote.title}
      quoteStatus={quote.meta && quote.meta.quoteStatus}
      urlSlug={quote.url_slug}
      oneColumn={oneColumn}
      shortDescription={quote.meta.short_description}
      rule={user && user.rule}
    />
  ));

  return (
    <Fragment>
      <div className="QuoteCardList">
        {quoteList && quoteList.length === 0 && (
          <div className="empty-list">아직 등록된 견적요청이 없습니다.</div>
        )}
        {quoteList}
        {prefetching &&
          createArray(columnCount).map(num => <FakeQuoteCard key={num} oneColumn={oneColumn} />)}
      </div>
      <Tooltip effect="solid" className="tooltip" />
    </Fragment>
  );
};

QuoteCardList.defaultProps = {
  quotes: [],
  oneColumn: false,
  width: 0,
  placeholderCount: 12,
  hideUsername: false,
};

export default QuoteCardList;



// WEBPACK FOOTER //
// ./src/components/common/QuoteCardList/QuoteCardList.js